import React, {Component}   from 'react';
import {
  Table as TableB,
  FormControl,
  Button
}                           from 'react-bootstrap';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import {REDEMPTION_SUMMARY} from 'actions/const';

class Table extends Component {
  render() {
    let {
      isLoading,
      getTableData
    } = this.props;

    let {
      tableData,
      filterNid,
      filterCouponName
    } = this.props.redemptionsummary;

    let {
      setValue
    } = this.props.actions;

    var tr = '';

    if (isLoading) {
      tr = (
        <tr>
          <td colSpan={15} style={{
            textAlign: 'center',
            color: '#808080'
          }}>
            <i className="fa fa-spinner fa-spin fa-3x"></i>
          </td>
        </tr>
      );
    } else if (tableData.length === 0) {
      tr = (
        <tr>
          <td colSpan={15} style={{
              textAlign: 'center',
              color: '#808080'}}>
          No Data Available
        </td>
        </tr>
      );
    } else {
      tr = tableData.map((data, index) =>
        <tr key={index}>
          <td>{data.nid}</td>
          <td>{data.couponName}</td>
          <td>{data.count}</td>
          <td></td>
        </tr>
      );
    }

    return (
      <TableB hover responsive>
        <thead>
          <tr>
            <th>NID</th>
            <th>COUPON NAME</th>
            <th>COUNT</th>
            <th></th>
          </tr>
          <tr>
            <td>
              <FormControl
  							type="text"
  							value={filterNid}
  							onChange={(e) => setValue(REDEMPTION_SUMMARY, 'filterNid', e.target.value)}/>
            </td>
            <td>
              <FormControl
  							type="text"
  							value={filterCouponName}
  							onChange={(e) => setValue(REDEMPTION_SUMMARY, 'filterCouponName', e.target.value)}/>
            </td>
            <td></td>
            <td>
              <Button
                bsStyle="primary"
                onClick={() => getTableData()}
                >
                SEARCH
              </Button>
            </td>
          </tr>
        </thead>
        <tbody>
          {tr}
        </tbody>
      </TableB>
    );
  }
}

function mapStateToProps(state) {
	var {redemptionsummary} = state;
	const props = {
		redemptionsummary
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);



// WEBPACK FOOTER //
// ./components/RedemptionSummary/Table.js